import { useI18n } from '@/i18n/i18n-context'
import { Card } from '@/ui/card'

/** 429 from `challenge` is a real, distinct signal the API deliberately makes (unlike verify's
 * uniform 410 — see D-8), so it earns its own honest message rather than folding into DeadLinkScreen. */
export function RateLimitedScreen() {
  const { t } = useI18n()
  return (
    <Card className="flex flex-col gap-2 text-center">
      <h1 className="text-lg font-semibold text-slate-900">{t('tooManyAttemptsTitle')}</h1>
      <p className="text-sm text-slate-600">{t('tooManyAttemptsDetail')}</p>
    </Card>
  )
}
